// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__2Tw9l","tab":"ProcedureTabs_tab__1QXId"};